module.exports = __webpack_public_path__ + "img/Icon fa-solid-user-large.529cab09.svg";